export default () => ({
  textInput: {
    '& .MuiInputBase-input ': {
      height: '56px',
      paddingLeft: '16px',
    },
  },
});
